export default "__VITE_ASSET__BlgbQovD__"